import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import moment from "moment";
import { useTaskContext } from "../context/TaskContext";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";

// Colores de etiquetas
const pastelColors = ["#FBE6FC", "#D9F4F8", "#FFECE1", "#E1F6FF", "#6ae88e"];

const tagTextColors = ["#FF00B8", "#268FB0", "#FF5C00", "#2C62B4", "#038554"];

const CreateTaskModal = ({
  isOpen,
  onRequestClose,
  taskToEdit,
  listName,
  projectId,
  customStyles, // tus estilos para Modal
  usuarios = [], // <-- AÑADIDO: lista de usuarios que recibes como prop
}) => {
  const { firstName, lastName, avatarUrl, user: authUser } = useAuth();
  const { createTask, updateTask } = useTaskContext();

  const [title, setTitle] = useState("");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [user, setUser] = useState(`${firstName} ${lastName}`);
  const [tags, setTags] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);

  const isEditing = !!taskToEdit;

  // Cargar datos si estamos editando
  useEffect(() => {
    if (isEditing && taskToEdit) {
      setTitle(taskToEdit.title || "");
      setDate(taskToEdit.date || moment().format("YYYY-MM-DD"));
      setUser(taskToEdit.user || `${firstName} ${lastName}`);
      setTags(taskToEdit.tags || []);
      setTaggedUsers(taskToEdit.taggedUsers || []);
    } else {
      // Nuevo: limpiar campos
      setTitle("");
      setDate(moment().format("YYYY-MM-DD"));
      setUser(`${firstName} ${lastName}`);
      setTags([]);
      setTaggedUsers([]);
    }
  }, [taskToEdit, isEditing, firstName, lastName]);

  // Guardar la tarea (nueva o editada)
  const handleSave = async () => {
    if (!title.trim()) {
      Swal.fire("Error", "El título no puede estar vacío", "error");
      return;
    }
    if (!projectId) {
      Swal.fire("Error", "No se encontró projectId del proyecto", "error");
      return;
    }

    const taskData = {
      projectId,
      status: listName,
      title,
      date,
      userName: user,
      avatarUrl,
      userId: authUser.uid,
      tags,
      taggedUsers,
      comments: taskToEdit?.comments || [],
      attachments: taskToEdit?.attachments || [],
    };

    if (isEditing) {
      await updateTask(taskToEdit.id, taskData);
    } else {
      await createTask(taskData);
    }
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={isEditing ? "Editar Tarea" : "Agregar Tarea"}
    >
      <button className="modal-close" onClick={onRequestClose}>
        <i className="bi bi-x-lg"></i>
      </button>
      <h2 style={{ textAlign: "center" }}>
        {isEditing ? "Editar Tarea" : "Agregar Tarea"}
      </h2>

      {/* Título */}
      <label>Título:</label>
      <input
        type="text"
        style={customStyles.input}
        placeholder="Agrega un título"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      {/* Fecha */}
      <label>Fecha:</label>
      <input
        type="date"
        style={customStyles.input}
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />

      {/* Etiquetas (tags) */}
      <label>
        Etiquetas:{" "}
        <p style={{ fontSize: "12px", color: "#888", margin: "0" }}>
          (Puedes agregar hasta 5 etiquetas).
        </p>
      </label>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          borderRadius: "8px",
          marginTop: "5px",
          marginBottom: "5px",
          overflowY: "auto",
        }}
      >
        {tags.map((tag, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: pastelColors[index % pastelColors.length],
              color: tagTextColors[index % tagTextColors.length],
              fontWeight: "bold",
              borderRadius: "20px",
              padding: "6px 12px",
              fontSize: "12px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            {tag}
            <span
              style={{
                marginLeft: "8px",
                cursor: "pointer",
                fontWeight: "bold",
                color: "rgba(0, 0, 0, 0.6)",
                alignItems: "center",
              }}
              onClick={() =>
                setTags(tags.filter((_, tagIndex) => tagIndex !== index))
              }
            >
              <i className="bi bi-x"></i>
            </span>
          </div>
        ))}
        {tags.length < 5 && (
          <input
            type="text"
            placeholder="Escribe y presiona Enter..."
            style={customStyles.input}
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.value.trim() !== "") {
                if (!tags.includes(e.target.value.trim())) {
                  setTags([...tags, e.target.value.trim()]);
                }
                e.target.value = "";
              }
            }}
          />
        )}
      </div>

      {/* Usuario (texto simple) */}
      <label>Usuario:</label>
      <input
        type="text"
        placeholder="Agrega el usuario"
        style={customStyles.input}
        value={user}
        onChange={(e) => setUser(e.target.value)}
      />

      {/* Etiquetar usuarios */}
      <label>Etiquetar usuarios:</label>
      <div
        style={{
          ...customStyles.input,
          display: "flex",
          flexWrap: "wrap",
          gap: "5px",
          alignItems: "center",
        }}
      >
        {taggedUsers.map((userObj, index) => (
          <div
            key={userObj.id || index}
            style={{
              display: "flex",
              alignItems: "center",
              background: "#007bff",
              color: "#fff",
              borderRadius: "5px",
              padding: "4px 8px",
              fontSize: "14px",
              cursor: "pointer",
              marginBottom: "4px",
            }}
            onClick={() =>
              setTaggedUsers(taggedUsers.filter((_, i) => i !== index))
            }
          >
            <img
              src={userObj.avatarUrl || "/img/avatar2.jpg"}
              alt="avatar"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                marginRight: "5px",
                objectFit: "cover"
              }}
            />
            <span style={{ marginRight: "5px" }}>
              {userObj.nombre
                ? `${userObj.nombre} ${userObj.apellido}`
                : userObj.email}
            </span>
            <i className="bi bi-x"></i>
          </div>
        ))}

        <select
          onChange={(e) => {
            const selectedUserId = e.target.value;
            if (selectedUserId) {
              const selectedUser = usuarios.find(
                (u) => u.id === selectedUserId
              );
              if (
                selectedUser &&
                !taggedUsers.some((u) => u.id === selectedUser.id)
              ) {
                setTaggedUsers([...taggedUsers, selectedUser]);
              }
            }
            e.target.value = "";
          }}
          style={{
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
            flexGrow: 1,
          }}
        >
          <option value="">Agregar usuario</option>
          {usuarios
            .filter((u) => {
              // Excluir si ya está etiquetado
              if (taggedUsers.some((tu) => tu.id === u.id)) return false;
              // Excluir si no tiene ID o si nombre, apellido y email están vacíos o solo espacios
              return (
                u.id &&
                (u.nombre?.trim() || u.apellido?.trim() || u.email?.trim())
              );
            })
            .map((u) => {
              const display = `${u.nombre ? u.nombre.trim() : ""} ${
                u.apellido ? u.apellido.trim() : ""
              }`.trim();
              return display ? (
                <option key={u.id} value={u.id}>
                  {display}
                </option>
              ) : null;
            })
            .filter((option) => option !== null)}
        </select>
      </div>

      {/* Botón Guardar/Actualizar */}
      <div style={{ textAlign: "center" }}>
        <button style={customStyles.button} onClick={handleSave}>
          {isEditing ? "Actualizar" : "Guardar"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateTaskModal;